{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$ref": "#/definitions/IMenuItemsApiResponse",
  "definitions": {
    "IMenuItemsApiResponse": {
      "type": "object",
      "properties": {
        "status": {
          "type": "string",
          "const": "ok"
        },
        "panel": {
          "type": "object",
          "properties": {
            "container_id": {
              "type": "string",
              "const": "left"
            },
            "items": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "css": {
                    "type": "string"
                  },
                  "enabled": {
                    "type": "boolean"
                  },
                  "id": {
                    "type": "number"
                  },
                  "link": {
                    "type": ["string", "null"]
                  },
                  "text": {
                    "type": "string"
                  },
                  "items": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "css": {
                          "type": "string"
                        },
                        "enabled": {
                          "type": "boolean"
                        },
                        "id": {
                          "type": "number"
                        },
                        "link": {
                          "type": "string"
                        },
                        "text": {
                          "type": "string"
                        }
                      },
                      "required": ["css", "enabled", "id", "link", "text"],
                      "additionalProperties": false
                    }
                  }
                },
                "required": ["css", "enabled", "id", "link", "text"],
                "additionalProperties": false
              }
            }
          },
          "required": ["container_id", "items"],
          "additionalProperties": false
        },
        "carRental": {}
      },
      "required": ["status", "panel", "carRental"],
      "additionalProperties": false
    }
  }
}
